import { call, put, takeLatest } from "redux-saga/effects";
import { fetchProfileFailure, fetchProfileSuccess, updateProfileFailure, updateProfileSuccess } from "./profileAction";
import { editProfileEffect, ViewProfileEffect } from "./profileEffect";
import { FETCH_PROFILE_REQUEST, UPDATE_PROFILE_REQUEST } from "./profileType";


function* updateProfileSaga(action) {

    try {
      const ProfileDatas = action.payload;
      const updateProfile = yield call(
        editProfileEffect,
        ProfileDatas.ProfileId,
        ProfileDatas.ProfileData
      );
      yield put(updateProfileSuccess(updateProfile));
    } catch (error) {
      const backendMessage = error.response?.data?.errorFields || error.message || "Login failed";
      yield put(updateProfileFailure(backendMessage));
    }
  }
  function* fetchProfileSaga(action) {
 
    try {
      const Profile = yield call(ViewProfileEffect, action.payload.ProfileId);

      const doctorData =Profile.data ||Profile;
      yield put(fetchProfileSuccess(doctorData));
    } catch (error) {
      yield put(fetchProfileFailure(error.message));
    }
  }
  export function* ProfileSagas() {
    yield takeLatest(UPDATE_PROFILE_REQUEST, updateProfileSaga);
    yield takeLatest(FETCH_PROFILE_REQUEST, fetchProfileSaga);
 
  }